import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import classnames from "classnames";
import { DebounceInput } from "react-debounce-input";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { InputGroup, InputGroupText } from "reactstrap";
import Header from "../../components/Header";
import HeaderTitle from "../../components/HeaderTitle";
import NewJobs from "../../components/admin/detailing/NewJobs";
import CheckingComplete from "../../components/admin/detailing/CheckingComplete";
import RevisionGenerated from "../../components/admin/detailing/RevisionGenerated";
import CheckingInProgress from "../../components/admin/detailing/CheckingInProgress";
import WaitingForChecking from "../../components/admin/detailing/WaitingForChecking";
import WaitingForDetailing from "../../components/admin/detailing/WaitingForDetailing";
import DetailingInProgress from "../../components/admin/detailing/DetailingInProgress";
import WaitingForScrubbing from "../../components/admin/detailing/WaitingForScrubbing";
import Scrubbing from "../../components/admin/detailing/Scrubbing";
import WaitingForLookOver from "../../components/admin/detailing/WaitingForLookOver";
import LookOver from "../../components/admin/detailing/LookOver";
import {
  Card,
  CardBody,
  Col,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";

const NEW_JOBS_TAB = "NEW_JOBS_TAB";
const WAITING_FOR_DETAILING_TAB = "WAITING_FOR_DETAILING_TAB";
const DETAILING_TAB = "DETAILING_TAB";
const WAITING_FOR_CHECKING_TAB = "WAITING_FOR_CHECKING_TAB";
const CHECKING_IN_PROGRESS_TAB = "CHECKING_IN_PROGRESS_TAB";
const WAITING_FOR_SCRUBBING_TAB = "WAITING_FOR_SCRUBBING_TAB";
const SCRUBBING_TAB = "SCRUBBING_TAB";
const WAITING_FOR_LOOK_OVER_TAB = "WAITING_FOR_LOOK_OVER_TAB";
const LOOK_OVER_TAB = "LOOK_OVER_TAB";
const CHECKING_COMPLETE_TAB = "CHECKING_COMPLETE_TAB";
const REVISION_GENERATED_TAB = "REVISION_GENERATED_TAB";
const DEFAULT_TABS_TO_LOAD = [
  NEW_JOBS_TAB,
  WAITING_FOR_DETAILING_TAB,
  DETAILING_TAB,
  WAITING_FOR_CHECKING_TAB,
  CHECKING_IN_PROGRESS_TAB,
  WAITING_FOR_SCRUBBING_TAB,
  SCRUBBING_TAB,
  WAITING_FOR_LOOK_OVER_TAB,
  LOOK_OVER_TAB,
  CHECKING_COMPLETE_TAB,
  REVISION_GENERATED_TAB,
];

const Detailing = () => {
  const location = useLocation();
  const [reloadTabs, setReloadTabs] = useState(DEFAULT_TABS_TO_LOAD);
  const [sequencesTotal, setSequencesTotal] = useState(0);
  const [detailingTotal, setDetailingTotal] = useState(0);
  const [checkingCompleteTotal, setCheckingCompleteTotal] = useState(0);
  const [revisionGeneratedTotal, setRevisionGeneratedTotal] = useState(0);
  const [waitingForCheckingTotal, setWaitingForCheckingTotal] = useState(0);
  const [checkingInProgressTotal, setCheckingInProgressTotal] = useState(0);
  const [waitingForScrubbingTotal, setWaitingForScrubbingTotal] = useState(0);
  const [scrubbingTotal, setScrubbingTotal] = useState(0);
  const [waitingForLookOverTotal, setWaitingForLookOverTotal] = useState(0);
  const [lookOverTotal, setLookOverTotal] = useState(0);
  const [waitingForDetailingTotal, setWaitingForDetailingTotal] = useState(0);
  const [selectedTab, setSelectedTab] = useState(NEW_JOBS_TAB);
  const [search, setSearch] = useState("");

  useEffect(() => {
    if (location.state?.tab) {
      setSelectedTab(location.state.tab);
    }
  }, [location.state]);

  return (
    <Container fluid>
      <Header className="mb-3 ">
        <HeaderTitle className="d-flex justify-content-between align-items-center w-100">
          <span className="text-dark">Jobs In Detailing</span>
          <InputGroup size="m" className="mb-0" style={{ maxWidth: "280px" }}>
            <DebounceInput
              minLength={2}
              debounceTimeout={500}
              className="form-control"
              placeholder="Search for.."
              value={search}
              onChange={(evt) => setSearch(evt.target.value)}
            />
            <InputGroupText className="search-jobs input-group-text bg-primary text-white border-left-0 border-primary">
              <FontAwesomeIcon icon={faSearch} />
            </InputGroupText>
          </InputGroup>
        </HeaderTitle>
      </Header>
      <Row>
        <Col className="flex-grow-1">
          <Nav
            tabs
            className="d-flex text-center flex-nowrap job-details-nav cursor-pointer mt-3"
          >
            <div className="d-flex flex-grow-1">
              <NavItem>
                <NavLink
                  className={classnames({
                    active: selectedTab === NEW_JOBS_TAB,
                  })}
                  onClick={() => setSelectedTab(NEW_JOBS_TAB)}
                >
                  {`New Jobs (${sequencesTotal})`}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: selectedTab === WAITING_FOR_DETAILING_TAB,
                  })}
                  onClick={() => setSelectedTab(WAITING_FOR_DETAILING_TAB)}
                >
                  {`Waiting for Detailing (${waitingForDetailingTotal})`}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: selectedTab === DETAILING_TAB,
                  })}
                  onClick={() => setSelectedTab(DETAILING_TAB)}
                >
                  {`Detailing (${detailingTotal})`}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: selectedTab === WAITING_FOR_CHECKING_TAB,
                  })}
                  onClick={() => setSelectedTab(WAITING_FOR_CHECKING_TAB)}
                >
                  {`Waiting for Check (${waitingForCheckingTotal})`}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: selectedTab === CHECKING_IN_PROGRESS_TAB,
                  })}
                  onClick={() => setSelectedTab(CHECKING_IN_PROGRESS_TAB)}
                >
                  {`Checking (${checkingInProgressTotal})`}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: selectedTab === WAITING_FOR_SCRUBBING_TAB,
                  })}
                  onClick={() => setSelectedTab(WAITING_FOR_SCRUBBING_TAB)}
                >
                  {`Waiting for Scrubbing (${waitingForScrubbingTotal})`}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: selectedTab === SCRUBBING_TAB,
                  })}
                  onClick={() => setSelectedTab(SCRUBBING_TAB)}
                >
                  {`Scrubbing (${scrubbingTotal})`}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: selectedTab === WAITING_FOR_LOOK_OVER_TAB,
                  })}
                  onClick={() => setSelectedTab(WAITING_FOR_LOOK_OVER_TAB)}
                >
                  {`Waiting for Look Over (${waitingForLookOverTotal})`}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: selectedTab === LOOK_OVER_TAB,
                  })}
                  onClick={() => setSelectedTab(LOOK_OVER_TAB)}
                >
                  {`Look Over (${lookOverTotal})`}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: selectedTab === CHECKING_COMPLETE_TAB,
                  })}
                  onClick={() => setSelectedTab(CHECKING_COMPLETE_TAB)}
                >
                  {`Ready for Review (${checkingCompleteTotal})`}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: selectedTab === REVISION_GENERATED_TAB,
                  })}
                  onClick={() => setSelectedTab(REVISION_GENERATED_TAB)}
                >
                  {`Rev Generated (${revisionGeneratedTotal})`}
                </NavLink>
              </NavItem>
            </div>
          </Nav>
        </Col>
      </Row>
      <Row>
        <Col className="flex-grow-1">
          <TabContent activeTab={selectedTab}>
            <TabPane tabId={NEW_JOBS_TAB}>
              <Card className="box-shadow-none border-left border-bottom border-right">
                <CardBody>
                  <NewJobs
                    setSequencesTotal={setSequencesTotal}
                    sequencesTotal={sequencesTotal}
                    setReloadTabs={setReloadTabs}
                    reloadTabs={reloadTabs}
                    tabName={NEW_JOBS_TAB}
                    search={search}
                  />
                </CardBody>
              </Card>
            </TabPane>
            <TabPane tabId={WAITING_FOR_DETAILING_TAB}>
              <Card className="box-shadow-none border-left border-bottom border-right">
                <CardBody>
                  <WaitingForDetailing
                    setSequencesTotal={setWaitingForDetailingTotal}
                    sequencesTotal={waitingForDetailingTotal}
                    setReloadTabs={setReloadTabs}
                    reloadTabs={reloadTabs}
                    tabName={WAITING_FOR_DETAILING_TAB}
                    search={search}
                  />
                </CardBody>
              </Card>
            </TabPane>
            <TabPane tabId={DETAILING_TAB}>
              <Card className="box-shadow-none border-left border-bottom border-right">
                <CardBody>
                  <DetailingInProgress
                    setSequencesTotal={setDetailingTotal}
                    sequencesTotal={detailingTotal}
                    setReloadTabs={setReloadTabs}
                    reloadTabs={reloadTabs}
                    tabName={DETAILING_TAB}
                    search={search}
                  />
                </CardBody>
              </Card>
            </TabPane>
            <TabPane tabId={WAITING_FOR_CHECKING_TAB}>
              <Card className="box-shadow-none border-left border-bottom border-right">
                <CardBody>
                  <WaitingForChecking
                    setSequencesTotal={setWaitingForCheckingTotal}
                    sequencesTotal={waitingForCheckingTotal}
                    setReloadTabs={setReloadTabs}
                    reloadTabs={reloadTabs}
                    tabName={WAITING_FOR_CHECKING_TAB}
                    search={search}
                  />
                </CardBody>
              </Card>
            </TabPane>
            <TabPane tabId={CHECKING_IN_PROGRESS_TAB}>
              <Card className="box-shadow-none border-left border-bottom border-right">
                <CardBody>
                  <CheckingInProgress
                    setSequencesTotal={setCheckingInProgressTotal}
                    sequencesTotal={checkingInProgressTotal}
                    setReloadTabs={setReloadTabs}
                    reloadTabs={reloadTabs}
                    tabName={CHECKING_IN_PROGRESS_TAB}
                    search={search}
                  />
                </CardBody>
              </Card>
            </TabPane>
            <TabPane tabId={WAITING_FOR_SCRUBBING_TAB}>
              <Card className="box-shadow-none border-left border-bottom border-right">
                <CardBody>
                  <WaitingForScrubbing
                    setSequencesTotal={setWaitingForScrubbingTotal}
                    sequencesTotal={waitingForScrubbingTotal}
                    setReloadTabs={setReloadTabs}
                    reloadTabs={reloadTabs}
                    tabName={WAITING_FOR_SCRUBBING_TAB}
                    search={search}
                  />
                </CardBody>
              </Card>
            </TabPane>
            <TabPane tabId={SCRUBBING_TAB}>
              <Card className="box-shadow-none border-left border-bottom border-right">
                <CardBody>
                  <Scrubbing
                    setSequencesTotal={setScrubbingTotal}
                    sequencesTotal={scrubbingTotal}
                    setReloadTabs={setReloadTabs}
                    reloadTabs={reloadTabs}
                    tabName={SCRUBBING_TAB}
                    search={search}
                  />
                </CardBody>
              </Card>
            </TabPane>
            <TabPane tabId={WAITING_FOR_LOOK_OVER_TAB}>
              <Card className="box-shadow-none border-left border-bottom border-right">
                <CardBody>
                  <WaitingForLookOver
                    setSequencesTotal={setWaitingForLookOverTotal}
                    sequencesTotal={waitingForLookOverTotal}
                    setReloadTabs={setReloadTabs}
                    reloadTabs={reloadTabs}
                    tabName={WAITING_FOR_LOOK_OVER_TAB}
                    search={search}
                  />
                </CardBody>
              </Card>
            </TabPane>
            <TabPane tabId={LOOK_OVER_TAB}>
              <Card className="box-shadow-none border-left border-bottom border-right">
                <CardBody>
                  <LookOver
                    setSequencesTotal={setLookOverTotal}
                    sequencesTotal={lookOverTotal}
                    setReloadTabs={setReloadTabs}
                    reloadTabs={reloadTabs}
                    tabName={LOOK_OVER_TAB}
                    search={search}
                  />
                </CardBody>
              </Card>
            </TabPane>
            <TabPane tabId={CHECKING_COMPLETE_TAB}>
              <Card className="box-shadow-none border-left border-bottom border-right">
                <CardBody>
                  <CheckingComplete
                    setSequencesTotal={setCheckingCompleteTotal}
                    sequencesTotal={checkingCompleteTotal}
                    setReloadTabs={setReloadTabs}
                    reloadTabs={reloadTabs}
                    tabName={CHECKING_COMPLETE_TAB}
                    search={search}
                  />
                </CardBody>
              </Card>
            </TabPane>
            <TabPane tabId={REVISION_GENERATED_TAB}>
              <Card className="box-shadow-none border-left border-bottom border-right">
                <CardBody>
                  <RevisionGenerated
                    setSequencesTotal={setRevisionGeneratedTotal}
                    sequencesTotal={revisionGeneratedTotal}
                    setReloadTabs={setReloadTabs}
                    reloadTabs={reloadTabs}
                    tabName={REVISION_GENERATED_TAB}
                    search={search}
                  />
                </CardBody>
              </Card>
            </TabPane>
          </TabContent>
        </Col>
      </Row>
    </Container>
  );
};

export default Detailing;
